import {ObjectBuilder} from '@gongxigames/framework/core';
import {Container, Sprite} from 'pixi.js';

export class Progress {
    public readonly container: Container = new Container();

    private readonly _bar: Sprite;
    private readonly _fill: Sprite;
    private readonly _cover: Sprite;
    private readonly _startX: number;
    private readonly _width: number;

    // fix blinking pixel issue [CLFR-2566]
    private readonly _coverWidthMultiplier = 0.96;

    constructor(
        private readonly _objectBuilder: ObjectBuilder,
        bar?: Sprite
    ) {
        if (bar) {
            this._bar = bar;
        } else {
            const elem = ObjectBuilder.resources.shared_sprite.loader.findByNameOrSrc('bar')!;

            this._bar = this._objectBuilder.buildSprite(elem);
        }

        this._fill = this._bar.getChildByName<Sprite>('fill');
        this._cover = this._fill.getChildByName<Sprite>('cover');
        this._startX = this._fill.getChildByName('startPoint').x;
        this._width = this._fill.getChildByName('endPoint').x - this._startX;

        this.container.addChild(this._bar);
    }

    public update(progress: number): void {
        const mask = this._fill.mask as Sprite;

        this._cover.x = this._startX + this._width * progress;
        mask.width = this._cover.x + this._cover.width * this._coverWidthMultiplier;
    }
}
